var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5739_41836)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 6.85714,
    fill: "#27D045"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.95431 31.0457 0 20 0C8.95431 0 0 8.95431 0 20C0 31.0457 8.95431 40 20 40Z",
    fill: "#27D045"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1652 31.5987C26.6897 31.5987 31.9788 26.3095 31.9788 19.7851C31.9788 13.2606 26.6897 7.97144 20.1652 7.97144C13.6407 7.97144 8.35156 13.2606 8.35156 19.7851C8.35156 26.3095 13.6407 31.5987 20.1652 31.5987Z",
    stroke: "white",
    strokeWidth: 2.03683
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.37387 26.5066L7.5 33.1467L14.3845 31.2321L14.7511 29.1138L10.2701 30.5396L11.4514 26.2622L9.37387 26.5066Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1875 30.5804C10.1875 30.5397 11.6133 25.8142 11.6133 25.8142L15.0352 29.0324L10.1875 30.5804Z",
    fill: "#27D045"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.062 13.9325C14.646 14.2211 14.2914 14.5893 14.0187 15.0159C13.746 15.4424 13.5606 15.9188 13.4732 16.4174C13.2695 18.0062 14.2472 19.6356 14.2472 19.6356C15.239 21.1111 16.4164 22.4529 17.7506 23.6278C18.9177 24.5513 20.2427 25.2553 21.6613 25.7054C22.4888 26.0358 23.394 26.1206 24.2684 25.9498C25.0435 25.737 25.7292 25.2799 26.2238 24.6462C26.3396 24.358 26.4217 24.0572 26.4682 23.75C26.5148 23.4805 26.5148 23.2049 26.4682 22.9353C26.4275 22.6501 23.4944 21.3058 23.2093 21.3873C22.9241 21.4688 22.6797 21.9984 22.3538 22.4465C22.0279 22.8946 21.9057 23.0983 21.5798 23.0983C21.2539 23.0983 19.8281 22.5279 18.4838 21.3058C17.716 20.6401 17.1159 19.8027 16.7322 18.8616C16.7322 18.8616 16.9766 18.5765 17.3025 18.1284C17.5561 17.8505 17.7378 17.5149 17.832 17.1507C17.832 16.947 16.6914 14.0547 16.4062 13.9325C15.9603 13.8698 15.5079 13.8698 15.062 13.9325Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5739_41836"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 6.85714,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.21e24c348f4dc160572cb31e53c3e691.svg";
export { ForwardRef as ReactComponent };